import React, { Component } from 'react'
import { Link } from 'gatsby'
import classNames from 'classnames'
import logo from '../../assets/images/logo-starship.png'
import { withScrollContext, withPopupContext } from '../../contexts'
import SearchBar from '../common/search/SearchBar'
import { SECTIONS } from './../../utils/url'

class MobileFloatingBar extends Component {
    state = {
        isSearchActive: false,
        isMobileMenuOpen: false,
        showMenu: false,
    }

    toggleMobileMenu = () => {
        this.setState((prevState) => ({
            isMobileMenuOpen: !prevState.isMobileMenuOpen,
        }))
    }

    componentDidMount() {
        const floatingBar = document.getElementById('mobile-floating-bar')
        const self = this
        const observer = new MutationObserver(function (event) {
            if (!floatingBar.classList.contains('open')) {
                self.closeFloatingSearchbar()
            }
        })

        observer.observe(floatingBar, {
            attributes: true,
            attributeFilter: ['class'],
            childList: false,
            characterData: false,
        })
    }


   

    openSearch = () => this.setState({ isSearchActive: true })
    closeSearch = () => this.setState({ isSearchActive: false })
    closeFloatingSearchbar = () => this.floatingSearchbar.closeSearchBar()

    render() {
        const { isFixedIndex, isHeaderOpen, children, popupContext, activeSection, noPopup } = this.props
     
        const { isSearchActive, isMobileMenuOpen } = this.state
        const bookmarks = (typeof window !== 'undefined' && JSON.parse(localStorage.getItem('bookmarks'))) || []

        return (
            <div id="mobile-floating-bar" className={`${isFixedIndex ? 'floating' : ''} ${isHeaderOpen ? 'open' : ''}`}>
                <div className="app-header">
                    <div className="wrapper">
                        <div className="mobile-header-links">
                            <button className="mobile-menu-toggle" onClick={this.toggleMobileMenu}>
                                <i className={`far ${isMobileMenuOpen ? 'fa-times' : 'fa-bars'} mobile-menu-toggle-icon`} />
                            </button>
                        </div>
                        <Link id="logo" to="/">
                            <img src={logo} alt="Starship Logo" title="Starship Logo" />
                        </Link>
                        <div className="header-links-right">
                        <div id="floating-searchbar-wrapper" className={isSearchActive ? 'active' : ''}>
                            <SearchBar id={'floating-searchbar'} activeSection={activeSection} ref={(el) => (this.floatingSearchbar = el)} withOverlay={false} openSearch={() => this.openSearch()} closeSearch={() => this.closeSearch()} />
                            <div className="overlay" />
                        </div>
                        <div className="header-links">
                            <Link to="/health-professionals/work-at-starship">Work at Starship</Link>
                            <Link to="/contact-us">Contact</Link>
                            {SECTIONS.HEALTH_PROFESSIONALS.key === activeSection && (
                                <Link className={bookmarks.length > 0 ? 'shortlist-not-empty' : 'shortlist-empty'} to="/guidelines/my-shortlist">
                                    My Shortlist {bookmarks.length > 0 && <i className="fas fa-bookmark" />}
                                </Link>
                            )}
                        </div>
                        <a href="https://supportstarship.org.nz/" rel="noopener noreferrer" target="_blank" className="donate-btn">
                            <i className="far fa-heart icon" />
                            <span>Donate</span>
                        </a>
                        </div>
                    </div>
                </div>

                {/* Mobile Navigation */}
                <div role="navigation" aria-label="Principale navigation mobile" className={`navbar-wrapper-mobile ${isMobileMenuOpen ? 'active' : ''}`}>
                    <div className="navbar-mobile">
                        <ul className="nav-menu-mobile">
                            <li className={classNames({ highlight: activeSection === SECTIONS.VISITOR.key })}>
                                <Link to={SECTIONS.VISITOR.url} onClick={this.toggleMobileMenu}>
                                    {SECTIONS.VISITOR.name}
                                </Link>
                            </li>
                            <li className={classNames({ highlight: activeSection === SECTIONS.HEALTH_PROFESSIONALS.key })}>
                                <Link to={SECTIONS.HEALTH_PROFESSIONALS.url} onClick={this.toggleMobileMenu}>
                                    {SECTIONS.HEALTH_PROFESSIONALS.name}
                                </Link>
                            </li>
                            <li className={classNames({ highlight: activeSection === SECTIONS.SUPPORT_STARSHIP.key })}>
                                <Link to={SECTIONS.SUPPORT_STARSHIP.url} onClick={this.toggleMobileMenu}>
                                    {SECTIONS.SUPPORT_STARSHIP.name}
                                </Link>
                            </li>
                            <li className={classNames({ highlight: activeSection === SECTIONS.SAFEKIDS.key })}>
                                <Link to={SECTIONS.SAFEKIDS.url} onClick={this.toggleMobileMenu}>
                                    {SECTIONS.SAFEKIDS.name}
                                </Link>
                            </li>
                            <li className={classNames({ highlight: activeSection === SECTIONS.POWER_TO_PROTECT.key })}>
                                <Link to={SECTIONS.POWER_TO_PROTECT.url} onClick={this.toggleMobileMenu}>
                                    {SECTIONS.POWER_TO_PROTECT.name}
                                </Link>
                            </li>
                            <li>
                                <Link to="/contact-us" onClick={this.toggleMobileMenu}>
                                    Contacts
                                </Link>
                            </li>
                            <li>
                                {SECTIONS.HEALTH_PROFESSIONALS.key === activeSection && (
                                    <Link to="/guidelines/my-shortlist" className={bookmarks.length > 0 ? 'shortlist-not-empty' : 'shortlist-empty'} onClick={this.toggleMobileMenu}>
                                        My Shortlist {bookmarks.length > 0 && <i className="fas fa-bookmark" />}
                                    </Link>
                                )}
                            </li>
                        </ul>
                    </div>
                </div>

                <div id="innerIndex">
                    <div className="inner">{children}</div>
                    {!noPopup && (
                        <div className="expand" onClick={() => popupContext?.togglePopup(popupContext.POPUP_ID.INDEX)}>
                            <i className="far fa-expand-alt icon" />
                        </div>
                    )}
                </div>
            </div>
        )
    }
}

export default withPopupContext(withScrollContext(MobileFloatingBar))
